<template>
    <div class="lds-widget-banner-container">
        <a
            :href="url"
            target="_blank"
            class="lds-widget-banner"
            :style="widgetColors"
        >
            <icon-advertising />
            <div class="lds-widget-banner__img">
                <picture>
                    <source
                        type="image/webp"
                        :srcset="currentImage"
                    >
                    <img
                        width="266"
                        height="100"
                        :src="`${s3Domain}images/banner-6.jpg`"
                        alt=""
                    >
                </picture>
            </div>
            <div class="lds-widget-banner__info">
                <p class="lds-widget-banner__title">
                    {{ widgetTitle }}
                </p>
                <p class="lds-widget-banner__text">
                    {{ widgetSubtitle }}
                </p>
            </div>
            <div class="lds-widget-banner__btn">
                <svg
                    class="lds-widget-banner__btn-arrow"
                    width="14"
                    height="12"
                    viewBox="0 0 14 12"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M8.25 0.203127L13.75 5.45313C13.9062 5.60938 14 5.79688 14 6.01563C14 6.20313 13.9062 6.39063 13.75 6.54688L8.25 11.7969C7.96875 12.0781 7.46875 12.0781 7.1875 11.7656C6.90625 11.4844 6.90625 10.9844 7.21875 10.7031L11.375 6.76563H0.75C0.3125 6.76563 0 6.42188 0 6.01563C0 5.57813 0.3125 5.26563 0.75 5.26563H11.375L7.21875 1.29688C6.90625 1.01563 6.90625 0.515627 7.1875 0.234377C7.46875 -0.0781233 7.9375 -0.0781233 8.25 0.203127Z" />
                </svg>
                {{ textButton }}
            </div>
        </a>
    </div>
</template>

<script setup>
import {computed, ref, toRef} from 'vue';
import useThemes from './composables/useThemes.js';
import getS3Domain from '../../common/s3Domain.js';
import IconAdvertising from "../../common/icons/IconAdvertising.vue";

const props = defineProps({
    settings: {
        type: Object,
        default: () => {
        },
    },

    url: {
        /** Может быть не задан для превью */
        type: [String, null],
        required: true,
    },

    widgetTitle: {
        type: String,
        default: '',
    },

    widgetSubtitle: {
        type: String,
        default: '',
    },

    textButton: {
        type: String,
        default: 'Получить деньги',
    },
});

const settings = toRef(props, 'settings');
const { widgetColors } = useThemes({ settings });

const s3Domain = ref(getS3Domain());
const currentImage = computed(() => (props.settings.imageBannerMini ? `${s3Domain.value}${props.settings.imageBannerMini}` : `${s3Domain.value}images/banner-6.webp`));
</script>

<style lang="scss" scoped>
.lds-widget-banner-container {
    container-name: lds-banner;
    container-type: inline-size;
}

.lds-widget-banner {
    display: flex;
    flex-direction: column;

    max-width: 298px;
    padding: 16px !important;
    box-sizing: border-box;

    border: 1px solid #EBEFF3 !important;
    border-radius: 24px !important;
    background-color: var(--lw-widget-bg);

    font-weight: 500 !important;
    text-decoration: none !important;

    text-align: left;

  position: relative;

    * {
        box-sizing: border-box !important;
        font-family: var(--lw-font-family), 'Arial', sans-serif !important;
        outline: none !important;
    }

    &__img {
        flex-shrink: 0;
        overflow: hidden;

        border-radius: 15px !important;

        img {
            max-width: 100%;
            vertical-align: middle;
            object-fit: cover;
        }
    }

    &__info {
        margin-top: 24px !important;
    }

    &__title {
        margin: 0 !important;

        font-size: 20px !important;
        line-height: 1.4;
        font-weight: 600 !important;
        color: var(--lw-title);
    }

    &__text {
        margin: 8px 0 0 !important;

        font-size: 14px !important;
        line-height: 20px;
        font-weight: 500 !important;
        white-space: pre-line;
        color: var(--lw-text);
    }

    &__btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;

        width: 100%;
        padding: 10px 16px !important;
        margin-top: 24px !important;

        font-size: 16px !important;
        font-weight: 500 !important;
        line-height: 1.5;
        text-decoration: none !important;
        color: var(--lw-btn-color);

        background-color: var(--lw-btn-bg);
        border: 0 !important;
        border-radius: 8px !important;
        outline: 0 !important;
        box-shadow: 0 0 20px 0 var(--lw-btn-shadow);

        cursor: pointer;

        transition: .2s;

        &:hover {
            background-color: var(--lw-btn-hover-bg);
            color: var(--lw-btn-hover-color);
        }

        &:active {
            background-color: var(--lw-btn-active-bg);
            color: var(--lw-btn-active-color);
        }

        svg {
            fill: currentColor;
            margin-right: 8px !important;
        }
    }

    @container lds-banner (max-width: 550px) {
        max-width: 343px;

        &__img img {
            width: 100%;
        }
    }

    @media (max-width: 550px) {
        max-width: 343px;

        &__img img {
            width: 100%;
        }
    }

    &__btn-arrow {
        fill: var(--lw-btn-icon-color);
    }
}
.widget-advertising-icon{
  position: absolute;
  top: 16px;
  left: 16px;
}
</style>
